export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((error) => formatApiError(error?.msg ?? error)).join(' ');
  if (typeof detail.msg === 'string') return detail.msg;
  return JSON.stringify(detail);
}